import { Button, Form, Modal } from "react-bootstrap";
import "./modalcss.scss";
import OTPInput from "react-otp-input";
import React, { useEffect, useState } from "react";
import WebService from "../../Services/WebService";
import { toast } from "react-toastify";
import HelperService from "../../Services/HelperService";
interface PropsData {
  contactInfo: any;
  show: boolean;
  handleHide: (flag: boolean) => void;
  emailVerify: boolean;
  // mobileVerify: boolean;
  action: string;
  from?: string;
}
const VerifyOTP = ({
  contactInfo,
  show,
  handleHide,
  emailVerify,
  from,
  action,
}: PropsData) => {
  const [otp, setOtp] = useState<string>("");
  const [otp1, setOtp1] = useState<string>("");
  const [resendDisabled, setResendDisabled] = useState<boolean>(false);
  const [resendDisabled1, setResendDisabled1] = useState<boolean>(false);
  const [emailVerifiedAt, setEmailVerifiedAt] = useState(emailVerify);

  const formatTime = (time: any) => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(
      2,
      "0",
    )}`;
  };
  // useEffect(() => {
  //   if (!emailVerifiedAt ) {
  //     handleHide(true);
  //   }
  // }, [emailVerifiedAt]);
  const handleResend = (loginField: string) => {
    if (loginField === "MOBILE_NUMBER") WebService.addLoader("resend1");
    else WebService.addLoader("resend2");
    return WebService.beforeLoginPostAPI({
      action: "otp/resend",
      body: {
        login_field: loginField,
        mobile_number: HelperService.removeDialCode(
          contactInfo?.mobile_number,
          contactInfo?.dial_code,
        ),
        email: contactInfo?.email,
        dial_code: contactInfo?.dial_code,
        country_code: contactInfo?.country_code,
      },
      isShowError: false,
    })
      .then((res: any) => {
        if (res?.status) {
          toast.success(res.message);
        } else {
          toast.error(res.message);
        }
      })
      .catch((error: any) => {
        toast.error(error?.response?.data?.message);
        WebService.removeLoader("verify-otp-btn");
        return error;
      })
      .finally(() => {
        if (loginField === "MOBILE_NUMBER") WebService.removeLoader("resend1");
        else WebService.removeLoader("resend2");
      });

    // SubmitOTPForm(getOTPData, "otp/resend");
  };
  const handleOTPVerify = (loginField: string, otp1: string) => {
    if (loginField === "MOBILE_NUMBER") {
      WebService.addLoader("verify-otp-btn");
      setResendDisabled(true);
    } else {
      WebService.addLoader("verify-otp-btn2");
      setResendDisabled1(true);
    }
    if (from === "PROFILE_ANALYSIS") {
      return WebService.postAPI({
        action: action,
        body: {
          login_field: loginField,
          // mobile_number: HelperService.removeDialCode(
          //   contactInfo?.mobile_number,
          //   contactInfo?.dial_code
          // ),
          email: contactInfo?.email,
          otp: otp1,
          dial_code: contactInfo?.dial_code,
          country_code: contactInfo?.country_code,
        },
        isShowError: false,
      })
        .then((res: any) => {
          if (res?.status) {
            // if (loginField === "MOBILE_NUMBER") {
            //   setMobileVerifiedat(false);
            // } else {
            setEmailVerifiedAt(false);
            // }
            localStorage.setItem("access_token", res?.access_token);
            toast.success(res.message);
            handleHide(true);
          } else {
            toast.error(res.message);
          }
        })
        .catch((error: any) => {
          toast.error(error?.response?.data?.message);
          WebService.removeLoader("verify-otp-btn");
          return error;
        })
        .finally(() => {
          if (loginField === "MOBILE_NUMBER") {
            WebService.removeLoader("verify-otp-btn");
            setResendDisabled(false);
          } else {
            WebService.removeLoader("verify-otp-btn2");
            setResendDisabled1(false);
          }
        });
    } else {
      return WebService.beforeLoginPostAPI({
        action: action,
        body: {
          login_field: loginField,
          // mobile_number: HelperService.removeDialCode(
          //   contactInfo?.mobile_number,
          //   contactInfo?.dial_code
          // ),
          email: contactInfo?.email,
          otp: otp1,
          dial_code: contactInfo?.dial_code,
          country_code: contactInfo?.country_code,
        },
        isShowError: false,
      })
        .then((res: any) => {
          if (res?.status) {
            // if (loginField === "MOBILE_NUMBER") {
            //   setMobileVerifiedat(false);
            // } else {
            setEmailVerifiedAt(false);
            // }
            if (res?.access_token) {
              HelperService.storeAccessToken(res?.access_token);
            } else {
              localStorage.setItem("access_token", res?.access_token);
            }
            toast.success(res.message);
            handleHide(true);
          } else {
            toast.error(res.message);
          }
        })
        .catch((error: any) => {
          toast.error(error?.response?.data?.message);
          WebService.removeLoader("verify-otp-btn");
          return error;
        })
        .finally(() => {
          if (loginField === "MOBILE_NUMBER") {
            WebService.removeLoader("verify-otp-btn");
            setResendDisabled(false);
          } else {
            WebService.removeLoader("verify-otp-btn2");
            setResendDisabled1(false);
          }
        });
    }
  };
  const [counter, setCounter] = useState<number>(90);
  return (
    <Modal
      show={show}
      onHide={() => handleHide(false)}
      //   className="right"
      keyboard={false}
      backdrop="static"
      centered
    >
      <Modal.Header closeButton className="border-bottom-0 pb-0 pt-1">
        {/* <Modal.Title>OTP Verification</Modal.Title> */}
      </Modal.Header>
      <Modal.Body className="pt-1">
        {/* {mobileVerifiedAt && (
          <React.Fragment>
            <Form>
              <h5>Verify Mobile Number</h5>
              <div className="login-form">
                <Form.Label className="label-text">
                  An OTP has been sent to {contactInfo?.dial_code}-
                  {contactInfo?.mobile_number &&
                    HelperService.removeDialCode(
                      contactInfo?.mobile_number,
                      contactInfo?.dial_code
                    )}{" "}
                  . The code is valid for 15 minutes.
                </Form.Label>
                <p className="para">Please enter OTP</p>
                <div className="otp-input">
                  <OTPInput
                    value={otp}
                    onChange={setOtp}
                    numInputs={6}
                    renderSeparator={<span>-</span>}
                    shouldAutoFocus={true}
                    inputStyle={{
                      width: "50px",
                      height: "50px",
                      margin: "0 10px",
                      fontSize: "20px",
                      borderRadius: "8px",
                      border: "1px solid #ccc",
                      textAlign: "center",
                    }}
                    containerStyle={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                    renderInput={(props: any) => <input {...props} />}
                  />
                </div>
                <br />
                <div className="d-flex justify-content-end">
                  <button
                    id="resend1"
                    onClick={() => handleResend("MOBILE_NUMBER")}
                    disabled={resendDisabled}
                    className="bg-white border-0 text-primary"
                  >
                    Resend OTP
                  </button>
                </div>
                <div className="col-12 d-flex justify-content-center">
                  <Button
                    disabled={otp.length < 6}
                    variant="primary"
                    id="verify-otp-btn"
                    className="btn btn-primary cursor-pointer mb-2"
                    style={{ width: "auto" }}
                    onClick={() => handleOTPVerify("MOBILE_NUMBER", otp)}
                  >
                    Verify OTP
                  </Button>
                </div>
              </div>
            </Form>
            <hr></hr>
          </React.Fragment>
        )} */}
        {emailVerifiedAt && (
          <Form className="mt-3">
            <div className="login-form">
              <h5>Verify Email</h5>

              <Form.Label className="label-text">
                An OTP has been sent to {contactInfo?.email} . The code is valid
                for 15 minutes.
              </Form.Label>
              <p className="para">Please enter OTP</p>
              <div className="otp-input">
                <OTPInput
                  value={otp1}
                  onChange={setOtp1}
                  numInputs={6}
                  renderSeparator={<span>-</span>}
                  shouldAutoFocus={true}
                  inputStyle={{
                    width: "50px",
                    height: "50px",
                    margin: "0 10px",
                    fontSize: "20px",
                    borderRadius: "8px",
                    border: "1px solid #ccc",
                    textAlign: "center",
                  }}
                  containerStyle={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  renderInput={(props: any) => <input {...props} />}
                />
              </div>
              <br />
              <div className="d-flex justify-content-end mb-2">
                <button
                  onClick={() => handleResend("EMAIL")}
                  disabled={resendDisabled1}
                  className="bg-white border-0 text-primary"
                  id="resend2"
                >
                  Resend OTP
                </button>
              </div>
              <div className="col-12 d-flex justify-content-center">
                <Button
                  disabled={otp1.length < 6}
                  variant="primary"
                  id="verify-otp-btn2"
                  className="btn btn-primary cursor-pointer mb-2"
                  style={{ width: "auto" }}
                  onClick={() => handleOTPVerify("EMAIL", otp1)}
                >
                  Verify OTP
                </Button>
              </div>
            </div>
          </Form>
        )}
      </Modal.Body>
      <div className="row">
        {/* <div className="col-6">
          <Button
            disabled={otp.trim() === ""}
            variant="primary"
            id="clear-btn"
            className="btn btn-primary w-100 cursor-pointer"
            onClick={clearOtp}
          >
            Clear OTP
          </Button>
        </div> */}
      </div>
    </Modal>
  );
};
export default VerifyOTP;
